import { fetchCheckoutConf, fetchCheckoutDetails } from "../api/api";

// Utility functions for updating page metadata dynamically
export const updatePageMetadata = (merchantData) => {
  if (!merchantData) return;

  const { companyName, logoUrl, description } = merchantData;

  // Update page title
  if (companyName) {
    document.title = companyName;
  }

  // Update meta description
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta && (description || companyName)) {
    const newDescription = description || `Secure checkout powered by ${companyName}`;
    descriptionMeta.setAttribute('content', newDescription);
  }

  // Update favicon
  if (logoUrl) {
    updateFavicon(logoUrl);
  }

  // Update apple touch icon
  if (logoUrl) {
    updateAppleTouchIcon(logoUrl);
  }

  // Update theme color if available
  if (merchantData.colour) {
    updateThemeColor(merchantData.colour);
  }
};

export const updateFavicon = (logoUrl) => {
  // Remove existing favicon
  const existingFavicon = document.querySelector('link[rel="icon"]');
  if (existingFavicon) {
    existingFavicon.remove();
  }

  // Create new favicon link
  const favicon = document.createElement('link');
  favicon.rel = 'icon';
  favicon.href = logoUrl;
  favicon.type = 'image/png';
  
  // Add to head
  document.head.appendChild(favicon);
};

export const updateAppleTouchIcon = (logoUrl) => {
  // Remove existing apple touch icon
  const existingAppleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (existingAppleIcon) {
    existingAppleIcon.remove();
  }

  // Create new apple touch icon link
  const appleIcon = document.createElement('link');
  appleIcon.rel = 'apple-touch-icon';
  appleIcon.href = logoUrl;
  
  // Add to head
  document.head.appendChild(appleIcon);
};

export const updateThemeColor = (color) => {
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', color);
  }
};

// Function to fetch tenant configuration and update metadata.
// Returns the resolved merchant data (companyName, logoUrl, ...) so callers
// can also use it as domain-derived branding — e.g. as a fallback merchant
// name on an error page, when the specific checkout session/config never
// loaded but the tenant itself is still identifiable from the domain.
// Uses the shared catalog/conf cache so MetadataBootstrap and CheckoutPage
// do not duplicate network calls.
export const fetchAndUpdateMetadata = async () => {
  try {
    // Try to get URL parameters first
    const urlParams = new URLSearchParams(window.location.search);
    const billingPlatformId = urlParams.get("billing_platform");
    const planId = urlParams.get("plan_id");

    let merchantData = null;

    // Fetch based on available parameters (shared cache with CheckoutPage).
    if (billingPlatformId) {
      const data = await fetchCheckoutDetails(billingPlatformId, planId);
      merchantData = data?.checkoutPageConfDto || null;
    } else {
      // Fallback to tenant configuration (resolved purely from the domain)
      merchantData = await fetchCheckoutConf();
    }

    if (merchantData) {
      updatePageMetadata(merchantData);
    }
    return merchantData;
  } catch (error) {
    console.warn('Failed to fetch merchant metadata:', error);
    // Fallback to default metadata - don't throw error
    return null;
  }
};
